export enum PageStatus {
  DRAFTED = 'drafted',
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished'
}

export interface IPage {
  portalPageId: number;
  parentPageId: number | null;
  title: string;
  slug: string;
  pageOrder: number;
  content: string;
  status: PageStatus;
}

export interface IPageAttributes {
  portalPageId?: number;
  parentPageId?: number | null;
  title?: string;
  slug?: string;
  pageOrder?: number;
  content?: string;
  status?: PageStatus;
}

export interface INewPage {
  parentPageId: number | null;
  title: string;
  slug: string;
  pageOrder: number;
  content: string;
  status: PageStatus;
}



// WEBPACK FOOTER //
// ./src/Entities/Pages.ts